<template>
  <v-container class="fill-height" fluid>
    <v-row justify="center" v-if="data.plan">
      <v-col cols="12" sm="10" md="6" xl="4">
        <div class="plan primary white--text">
          <h2>{{ data.plan.name }}</h2>
          <p>{{ data.plan.details }}</p>
          <p class="cost">{{ data.plan.cost }}</p>
        </div>
        <v-card class="pa-5" v-if="data.plan">
          <v-card-text>
            <h1>Subscription Summary</h1>
            <v-simple-table class="mt-5">
              <thead class="grey lighten-5">
                <tr>
                  <th class="text-left">Item</th>
                  <th class="text-right">Subscription</th>
                  <th class="text-right">Total with Tax</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ data.plan.name }}</td>
                  <td class="text-right">{{ data.plan.cost }}</td>
                  <td class="text-right">{{ (data.plan.amount * (1 + data.plan.taxPerc * 0.01)).toFixed(2) }} CHF</td>
                </tr>
              </tbody>
              <tfoot class="grey lighten-5">
                <tr>
                  <td></td>
                  <td class="text-right">Subtotal</td>
                  <td class="text-right">{{ (data.plan.amount * 1).toFixed(2) }} CHF</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-right">Taxes</td>
                  <td class="text-right">{{ (data.plan.amount * (data.plan.taxPerc * 0.01)).toFixed(2) }} CHF</td>
                </tr>
                <tr class="font-weight-bold">
                  <td></td>
                  <td class="text-right">Monthly Total</td>
                  <td class="text-right">{{ (data.plan.amount * (1 + data.plan.taxPerc * 0.01)).toFixed(2) }} CHF</td>
                </tr>
              </tfoot>
            </v-simple-table>
            <v-divider></v-divider>

            <div class="text-right">
              <form ref="checkoutForm" @submit.prevent="submitForm" class="my-5" aria-autocomplete="off" autocomplete="off" method="post" :action="checkoutSessionUrl">
                <input type="hidden" name="email" :value="user.email" />
                <input type="hidden" name="lookup_key" :value="data.plan.pg_plan_lookup" required />
                <input name="amount" :value="data.amount" type="hidden" required />
                <v-btn color="primary" type="submit" id="checkout-and-portal-button">Checkout</v-btn>
              </form>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text type="button" @click="gotoPlans">Change Plan</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {loadStripe} from "@stripe/stripe-js"
import plansData from "@/assets/plans/plans.json"

import axios from "axios"
import Vue from "vue"
import Component from "vue-class-component"
import {config} from "@/libs/utils"
import {cacheSrv} from "../../libs/cache/cache"

@Component
export default class Payment extends Vue {
  paymentUrl = config.VUE_APP_SERVER_PAYMENT_API
  publicToken = config.VUE_APP_PAYMENT_PUBLIC_TOKEN
  checkoutSessionUrl = config.VUE_APP_SERVER_PAYMENT_API + "/v1/secure/payment/create-checkout-session"

  plans = plansData.plans
  data = {
    plan: null,
    amount: 0,
  }
  user = this.$store.getters.profile
  token

  created() {
    const planId = this.$route.params.planId
    console.log("Plan ID", planId)

    this.$nextTick(() => {
      let plan = this.plans.find((plan) => plan.id == planId)
      if (!plan) {
        console.log("Plan not found")
        this.$router.push({name: "mapview"})
        return
      }
      Vue.set(this.data, "plan", plan)
      Vue.set(this.data, "amount", plan.amount)
    })
  }

  getToken() {
    const CACHE_KEY_SERVER = "mainmap"
    if (!this.token) {
      this.token = cacheSrv.cached(CACHE_KEY_SERVER + "_tok")
    }
    if (!this.token) {
      return null
    }
    return this.token
  }

  submitForm() {
    console.log("Submitting form")
    const form = this.$el.querySelector("form")
    if (form) {
      this.getToken()
      //append token to the form param
      const tokenInput = document.createElement("input")
      tokenInput.type = "hidden"
      tokenInput.name = "token"
      tokenInput.value = this.token
      form.appendChild(tokenInput)

      form.submit()
    }
  }

  async submitPayment() {
    console.log("Submitting payment")
    try {
      // Step 1: Get the client secret from the backend
      const response = await axios.post(paymentUrl + "/v1/secure/payment/create-payment-intent", {
        amount: this.amount,
      })

      const clientSecret = response.data.clientSecret

      // Step 2: Load Stripe.js
      const stripe = await loadStripe(publicToken)

      // Step 3: Confirm the payment
      const {error} = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      })

      if (error) {
        console.error(error)
        alert("Payment failed")
      } else {
        alert("Payment successful!")
      }
    } catch (error) {
      console.error(error)
      alert("An error occurred")
    }
  }

  gotoPlans() {
    this.$router.push({name: "plans"})
  }
}
</script>

<style>
.plan {
  border: 1px solid #ccc;
  padding: 20px;
}

.cost {
  font-weight: bold;
  margin: 10px 0;
}
.large-field {
  font-size: 20px;
  font-weight: bold;
}
.large-field.amount {
  width: 200px;
}
</style>
